export const Y_AXIS_TICKS = ['CELEBRATE', 'SUPPORT', 'INTERVENE'];

export const FILTER_OPTIONS_MAP = {
  'Last Month': 'last_month',
  'Last 3 Months': '3_months',
  'Last 6 Months': '6_months'
};

export const FILTER_OPTIONS = Object.keys(FILTER_OPTIONS_MAP);
export const DEFAULT_FILTER_VALUE = 'Last 3 Months';
